<template>
  <li>
    <div class="col-md-12 col-sm-12 outside">
      <div class="mystyle">
        <div class="row margin10">
          <div class="form-group test">
            <div class="fontSize20 color">
              日期：{{ data.timeBegin }}~{{ data.timeUntil }}
            </div>
          </div>
        </div>
        <div class="row margin10">
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              每個月費/月:
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">${{ data.serviceFee }}</div>
            </div>
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              出班費/班:
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">${{ data.feePerShift }}</div>
            </div>
          </div>
        </div>
        <div class="row margin10">
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              超過/次數:
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">{{ data.shiftLimit }}次</div>
            </div>
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              每班車資:
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">${{ data.feePerOverShiftLimit }}</div>
            </div>
          </div>
        </div>
        <div class="row margin10">
          <div class="form-group">
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              乘客險月費:
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">${{ data.insuranceForUser }}</div>
            </div>
            <label class="control-label col-md-2 col-sm-2 col-xs-12">
              車資比例(每班總金額):
            </label>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <div class="fontSize16">{{ data.fareCommission }}%</div>
            </div>
            <div
              v-if="show"
              @click="remove"
              class="col-md-2 col-sm-2 col-xs-2 fontSize16 delete_btn"
            >
              刪除
            </div>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
export default {
  props: ['data', 'index', 'show'],
  methods: {
    remove() {
      // console.log('----------->index', this.index)
      this.$emit('remove-payment-item', this.index)
    },
  },
}
</script>

<style scoped>
.outside {
  border: solid 2px #ffb5b5;
  margin-bottom: 10px;
}
.color {
  background-color: bisque;
}
.delete_btn {
  text-align: center;
  color: #ff5b5b;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/driver/PaymentItem.vue